import Link from 'next/link';
import clz from 'classnames';
import { FunctionComponent } from 'react';

import styles from './NavDropDown.module.sass';
import { LinkItem } from '../common/types';

export interface NavDropDownProps {
    items: LinkItem[];
    onHide: () => void;
}

const NavDropDown: FunctionComponent<NavDropDownProps> = ({ items, onHide }) => {
    const listComps = items.map(({ id, path, text, icon, description, disabled }) => (
        <Link key={id} href={path}>
            <li className={clz(styles.dropdownItem, { [styles.disabled]: disabled })}>
                <img className={styles.icon} src={icon} alt={text} />
                <div className={styles.linkTitle}>{text}</div>
                <div className={styles.linkDescription}>{description || ''}</div>
            </li>
        </Link>
    ));
    return (
        <ul className={styles.dropdown} onMouseLeave={onHide} onClick={onHide}>
            <span className={styles.arrow} />
            {listComps}
        </ul>
    );
};

export default NavDropDown;
